<template>
  <div>
    <h2>{{ $t('message.credit.otherMonthlyExpenses.heading') }}</h2>
    <p>{{ $t('message.credit.otherMonthlyExpenses.msg') }}</p>
    <mobialis-form-with-validation
      @onValidate="continueForm"
      novalidate
      v-av-analytics-form-submit="{ elementText: submitButtonText }"
    >
      <div class="row">
        <div class="col-sm-7">
          <mobialis-text-input-with-validation
            :mask-type="dollarMaskType"
            inputmode="numeric"
            pattern="[0-9]*"
            :label="$t('message.credit.otherMonthlyExpenses.carPayments')"
            :helper="$t('message.credit.otherMonthlyExpenses.carPaymentsHelper')"
            v-model.number="carPayments"
            vid="carPayments"
            data-cy="carPayments"
          ></mobialis-text-input-with-validation>
          <mobialis-text-input-with-validation
            :mask-type="dollarMaskType"
            inputmode="numeric"
            pattern="[0-9]*"
            :label="$t('message.credit.otherMonthlyExpenses.loanPayments')"
            v-model.number="loanPayments"
            vid="loanPayments"
            data-cy="loanPayments"
          ></mobialis-text-input-with-validation>
          <mobialis-text-input-with-validation
            :mask-type="dollarMaskType"
            inputmode="numeric"
            pattern="[0-9]*"
            :label="$t('message.credit.otherMonthlyExpenses.personalLineOfCredit')"
            v-model.number="personalLineOfCredit"
            vid="personalLineOfCredit"
            data-cy="personalLineOfCredit"
          ></mobialis-text-input-with-validation>
          <mobialis-text-input-with-validation
            :mask-type="dollarMaskType"
            inputmode="numeric"
            pattern="[0-9]*"
            :label="$t('message.credit.otherMonthlyExpenses.creditCardPayments')"
            :helper="$t('message.credit.otherMonthlyExpenses.creditCardPaymentsHelper')"
            v-model.number="creditCardPayments"
            vid="creditCardPayments"
            data-cy="creditCardPayments"
          ></mobialis-text-input-with-validation>
        </div>
      </div>
      <mobialis-button type="submit" class="mt-4 mb-1" data-cy="submit">
        {{ submitButtonText }}
      </mobialis-button>
      <p class="text-center small my-0">
        {{ $t('message.credit.disclaimer.noAffectScore') }}
      </p>
    </mobialis-form-with-validation>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { IncomeExpenses } from '@/mixins';
import TradeInSource from '@/utils/enums/tradeInSource';

export default {
  name: 'otherMonthlyExpenses',
  mixins: [IncomeExpenses],
  computed: {
    ...mapGetters({
      prequalificationTradeInEquityAssessmentEnabled: 'business/prequalificationTradeInEquityAssessmentEnabled',
    }),
    submitButtonText() {
      return this.prequalificationTradeInEquityAssessmentEnabled
        ? this.$t('message.common.continue')
        : this.$t('message.credit.viewAutoAffordability');
    },
  },
  methods: {
    async continueForm(isValid) {
      const tradeInCarfaxEnabled = this.$store.state.business.info.tradeInSource === TradeInSource.CARFAX;
      if (!isValid) {
        return;
      }
      this.$store.commit('SET_LOADING', true);
      this.updateOtherExpenses();
      try {
        await this.$store.dispatch('lead/updateLead');
        // @TODO remove trade-in vehicle components,test files,.. when VRM removed
        if (this.prequalificationTradeInEquityAssessmentEnabled) {
          if (tradeInCarfaxEnabled) {
            this.$router.push({
              name: `credit-carfax-trade-in-${this.baseRoute}`,
            });
          } else {
            this.$router.push({
              name: `trade-in-vehicle-${this.baseRoute}`,
            });
          }
        } else {
          this.$router.push({
            name: `credit-results-${this.baseRoute}`,
          });
        }
      } catch (err) {
        this.$log('Error in OtherMonthlyExpenses - Update Lead: ', err);
        this.$router.push({ name: `credit-in-error-${this.baseRoute}` });
      } finally {
        this.$store.commit('SET_LOADING', false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  color: #4b5863;
}
</style>
